<template>
  <div />
</template>

<script>
export default {
  name: "ReferralProgram"
};
</script>

<style scoped>

</style>